import { BrandColors } from "@/constants/theme";
import React from "react";
import { StyleSheet } from "react-native";
import { ButtonProps, Button as PaperButton } from "react-native-paper";

interface BrandButtonProps extends Omit<ButtonProps, 'theme'> {
    variant?: "primary" | "secondary" | "outline" | "error";
    loading?: boolean;
}

export function BrandButton({
    variant = "primary",
    loading = false,
    style,
    labelStyle,
    children,
    disabled,
    ...props
}: BrandButtonProps) {
    const getButtonStyle = () => {
        switch (variant) {
            case "secondary":
                return styles.secondaryButton;
            case "outline":
                return styles.outlineButton;
            case "error":
                return styles.errorButton;
            default:
                return styles.primaryButton;
        }
    };

    const getTextColor = () => {
        switch (variant) {
            case "outline":
                return BrandColors.primary;
            case "error":
                return BrandColors.white;
            default:
                return BrandColors.white;
        }
    };

    const mode = variant === "outline" ? "outlined" : "contained";

    return (
        <PaperButton
            mode={mode}
            loading={loading}
            disabled={disabled || loading}
            style={[styles.button, getButtonStyle(), style]}
            labelStyle={[styles.label, { color: getTextColor() }, labelStyle]}
            buttonColor={variant === "primary" ? BrandColors.primary : variant === "secondary" ? BrandColors.secondary : variant === "error" ? BrandColors.error : undefined}
            textColor={getTextColor()}
            {...props}
        >
            {children}
        </PaperButton>
    );
}

const styles = StyleSheet.create({
    button: {
        borderRadius: 8,
        paddingVertical: 4,
    },
    label: {
        fontSize: 14,
    },
    primaryButton: {
        backgroundColor: BrandColors.primary,
    },
    secondaryButton: {
        backgroundColor: BrandColors.secondary,
    },
    outlineButton: {
        borderColor: BrandColors.primary,
        borderWidth: 1,
    },
    errorButton: {
        backgroundColor: BrandColors.error,
    },
});
